/**
 * API Request Signing — HMAC-SHA256
 * Signs all mutating requests (POST, PUT, PATCH, DELETE) 
 * with X-SubZero-Signature and X-SubZero-Timestamp headers.
 */
import axios from 'axios';

const SIGNING_SECRET = process.env.REACT_APP_API_SIGNING_SECRET || '';

async function hmacSign(secret, message) {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey(
    'raw', enc.encode(secret), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign']
  );
  const sig = await crypto.subtle.sign('HMAC', key, enc.encode(message));
  return Array.from(new Uint8Array(sig)).map(b => b.toString(16).padStart(2, '0')).join('');
}

export function setupApiSigning() {
  if (!SIGNING_SECRET) return;

  axios.interceptors.request.use(async (config) => {
    const method = (config.method || 'get').toUpperCase();
    if (['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
      const url = new URL(config.url, window.location.origin);
      const path = url.pathname;
      if (path.startsWith('/api/')) {
        const timestamp = Math.floor(Date.now() / 1000).toString();
        const signature = await hmacSign(SIGNING_SECRET, `${timestamp}:${path}`);
        config.headers['X-SubZero-Signature'] = signature;
        config.headers['X-SubZero-Timestamp'] = timestamp;
      }
    }
    return config;
  });
}
